import React from 'react'
// import ReactGA from 'react-ga'
import ic_simplesassim from "../img/ic_simplesassim.png"
// import ic_fb from "../img/ic_fb.png"
import ic_insta from "../img/ic_insta.png"
import ic_youtube from "../img/ic_youtube.png"
// import ic_twitter from "../img/ic_twitter.png"
import { HashLink as Link } from 'react-router-hash-link'

class Contato extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  
  componentDidMount () {
    // ReactGA.initialize('UA-55278565-1')
    // ReactGA.pageview('/home')
  }

  render() {
    return (
      <section id="contato" className="contato">
        <nav>
          <h4>siga a gente</h4>
          <a href="mailto:sac@simplesassim.fun">
            <img src={ic_simplesassim} />
          </a>
          {/* <a href="/" target="_blank">
            <img src={ic_fb} />
          </a> */}
          <a href="https://www.instagram.com/sucosimplesassim/" target="_blank">
            <img src={ic_insta} />
          </a>
          <a href="#">
            <img src={ic_youtube} />
          </a>
          {/* <a href="/" target="_blank">
            <img src={ic_twitter} />
          </a> */}
        </nav>

        <div className="footerText">
          <p><b>SAC:</b> 0800 970 1931</p>
          <p><a href="mailto:quero@simplesassim.fun">quer cadastrar o produto?</a></p>
        </div>
      </section>
    )
  }
}

export default Contato